import type { CustomAttributeDefinition, CustomAttributeValues, UpdateCustomAttributeResponse } from "@jti/fe-common";
import type {
  AdditionalFieldResponseType,
  CasCustomAttrsApiContract,
  CustomAttributeWriteResponse,
  GetUserComplaintsResponse,
} from "@jti/rest-api-types";

import { CasBaseApi } from "../../CasBaseApi";
import { EndpointPlaceholders, Endpoints } from "../../CasEndpoints";

/** @deprecated Legacy proxy implementation — superseded by EVO. To be deleted after production verification. */
export class CasCustomAttrsApiLegacy extends CasBaseApi implements CasCustomAttrsApiContract {
  constructor(
    baseUrl: string,
    protected tenantToken: string,
    protected ciamToken: string,
    protected userUuid: string
  ) {
    super(baseUrl, tenantToken, ciamToken, userUuid);
  }

  protected preparePath(path: string): string {
    return path.replace(EndpointPlaceholders.UUID, this.userUuid);
  }

  async getCustomAttributes(): Promise<AdditionalFieldResponseType> {
    return this.request<CustomAttributeDefinition[]>(Endpoints.MarketCustomAttrsUrl, {
      method: "GET",
    });
  }

  async write(data: CustomAttributeValues): Promise<CustomAttributeWriteResponse> {
    const { customer } = await this.request<UpdateCustomAttributeResponse>(
      this.preparePath(Endpoints.CustomAttrsUrl),
      {
        body: JSON.stringify({
          custom_attributes: data,
        }),
        method: "PATCH",
      },
      true
    );

    return {
      dob: customer.dob,
      email: customer.email,
      firstname: customer.firstname,
      lastname: customer.lastname,
    };
  }

  async writeConsents(data: Pick<CustomAttributeValues, "consents" | "preferredLanguage">): Promise<void> {
    await this.write(data);
  }

  async getIsUserHasComplaints(): Promise<boolean> {
    const useRecaptchaInRequest = true;

    const response = await this.request<GetUserComplaintsResponse>(
      `/users/${this.userUuid}/complaints`,
      { method: "GET" },
      useRecaptchaInRequest
    );

    return response?.data?.has_complaints;
  }
}
